// src/panels/RightPanel.jsx
import React, { useState } from 'react';
import LayerPanel from './LayerPanel';
import PropertyPanel from './PropertyPanel';
import HierarchyPanel from './HierarchyPanel';
import LabelPanel from './LabelPanel';
import SearchPanel from './Searchpanel';

const RightPanel = () => {
  const [activeTab, setActiveTab] = useState('layer');

  const renderPanel = () => {
    switch (activeTab) {
      case 'layer': return <LayerPanel />;
      case 'property': return <PropertyPanel />;
      case 'hierarchy': return <HierarchyPanel />;
      case 'label': return <LabelPanel />;
      case 'search': return <SearchPanel />;
      default: return null;
    }
  };

  return (
    <div
    style={{
        width: '252px',
        backgroundColor: '#1e1e1e',
        color: '#fff',
        height: '93.5%', // leave space for top header
        borderLeft: '2px solid #333',
        display: 'flex',
        flexDirection: 'column',
        position: 'fixed',
        top: '36px', // shift whole panel down
        right:'0px',
      }}
    >
      {/* Tab Buttons */}
      <div style={{ display: 'flex', borderBottom: '1px solid #333' }}>
        <TabButton label="Layer" tab="layer" activeTab={activeTab} setActiveTab={setActiveTab} />
        <TabButton label="Property" tab="property" activeTab={activeTab} setActiveTab={setActiveTab} />
        <TabButton label="Hierarchy" tab="hierarchy" activeTab={activeTab} setActiveTab={setActiveTab} />
        <TabButton label="Label" tab="label" activeTab={activeTab} setActiveTab={setActiveTab} />
        <TabButton label="Search" tab="search" activeTab={activeTab} setActiveTab={setActiveTab} />
      </div>

      {/* Content */}
      <div
  style={{
    flex: 1,
    overflow: 'hidden',
    padding: '4px 10px 0px 2px',
    width: '100%',
    minWidth: '250px',
    maxWidth: '250px',
    boxSizing: 'border-box',
  }}
>
  {renderPanel()}
</div>

    </div>
  );
};

const TabButton = ({ label, tab, activeTab, setActiveTab }) => {
    const isActive = activeTab === tab;
  
    return (
      <button
        onClick={() => setActiveTab(tab)}
        style={{
          flex: 1,
          padding: '4px 2px',
          backgroundColor: isActive ? '#2d2d2d' : '#1e1e1e',
          color: isActive ? '#00d8ff' : '#aaa',
          borderBottom: isActive ? '2px solid #00d8ff' : '2px solid transparent',
          fontWeight: isActive ? '600' : 'normal',
          fontSize: '12px',
          cursor: 'pointer',
          // height: '10px',
          transition: 'all 0.2s ease',
          borderRight: '4px solid #333',
        }}
        onMouseEnter={(e) => {
          if (!isActive) e.target.style.backgroundColor = '#2a2a2a';
        }}
        onMouseLeave={(e) => {
          if (!isActive) e.target.style.backgroundColor = '#1e1e1e';
        }}
      >
        {label}
      </button>
    );
  };
  

export default RightPanel;
